import { AsyncPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { PublicRestService } from '@generated/be';
import { statusSkupinySablonOptions } from '@reza-ais-fe/reza-ais-fe-utils';
import {
  BrowseFilterComponent,
  BrowseTableDirective,
  ButtonsComponent,
  StatusIndicatorComponent,
} from '@shared/ui/components';
import { downloadFile, publicApiArgs } from '@shared/utils';
import { ButtonModule } from '@openng/optimus-ui/button';
import { TableModule } from '@openng/optimus-ui/table';
import { KatalogSkupinSablonFilterFormService } from '../../../services/katalog-skupin-sablon-filter-form.service';
import { KatalogSkupinSablonStateService } from '../../../services/katalog-skupin-sablon-state.service';
import { KatalogSkupinSablonFilterComponent } from '../katalog-skupin-sablon-filter/katalog-skupin-sablon-filter.component';

/** Veřejný katalog skupin šablon: filtr v akordeonu a tabulka se stažením PDF. */
@Component({
  selector: 'reza-katalog-skupin-sablon-overview-filter',
  imports: [
    AsyncPipe,
    DatePipe,
    ReactiveFormsModule,
    RouterLink,
    BrowseFilterComponent,
    BrowseTableDirective,
    TableModule,
    ButtonsComponent,
    ButtonModule,
    KatalogSkupinSablonFilterComponent,
    StatusIndicatorComponent,
  ],
  templateUrl: './katalog-skupin-sablon-overview-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KatalogSkupinSablonOverviewFilterComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly publicRestService = inject(PublicRestService);
  private readonly router = inject(Router);

  readonly filterForm = inject(KatalogSkupinSablonFilterFormService).filterForm;
  readonly state = inject(KatalogSkupinSablonStateService);
  readonly statusSkupinySablonOptions = statusSkupinySablonOptions;

  ngOnInit(): void {
    this.state.connectResult();
  }

  submitFilter(): void {
    this.state.findWithNewFilter(this.filterForm.value);
  }

  clearFilter(): void {
    this.state.findWithClearFilter(this.filterForm.value);
  }

  downloadPdf(id: number): void {
    this.publicRestService
      .getPdfSkupinySablon({ id })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => downloadFile(res, `${id}.pdf`));
  }

  downloadDokumentace(id: number): void {
    this.publicRestService
      .getDokumentace({ id }, ...publicApiArgs())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => downloadFile(res, `${id}.pdf`));
  }

  goBack(): void {
    this.router.navigate(['']);
  }
}
